module.exports = __webpack_public_path__ + "static/media/bo.68b087c0.svg";